import React from "react";
import { hydrate } from "react-dom";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import merge from "lodash/merge";
import { listingConfig } from "~configs/listing";
import { CurrencyContextProvider } from "~contextProviders/CurrencyContextProvider";
import Search from "~components/Search";
import { FavoritesContextProvider } from "~contextProviders/FavoritesContextProvider";
import { WidthContextProvider } from "~contextProviders/WidthContextProvider";
import { BREAKPOINTS } from "~constants/media";

const SearchEntry = ({ config, objects, filters }) => {
  return (
    <CookiesProvider>
      <BrowserRouter>
        <CurrencyContextProvider>
          <FavoritesContextProvider>
            <WidthContextProvider breakpoints={BREAKPOINTS}>
              <Search
                listingConfig={merge(listingConfig, config)}
                initialObjects={objects}
                initialFilters={filters}
              />
            </WidthContextProvider>
          </FavoritesContextProvider>
        </CurrencyContextProvider>
      </BrowserRouter>
    </CookiesProvider>
  );
};

if (typeof window['RC_APPS'] !== 'object') window['RC_APPS'] = {};

window['RC_APPS']['search'] = (container, widgetProps) => {
  hydrate(SearchEntry(widgetProps), container);
};

if (module.hot) {
  module.hot.accept();
}